module.exports = __webpack_public_path__ + "static/media/logout.7721e655.svg";